import { render, staticRenderFns } from "./roleUsers.vue?vue&type=template&id=5bab3837&scoped=true&"
import script from "./roleUsers.vue?vue&type=script&lang=ts&"
export * from "./roleUsers.vue?vue&type=script&lang=ts&"
import style0 from "./roleUsers.vue?vue&type=style&index=0&id=5bab3837&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab3837",
  null
  
)

export default component.exports